import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../UserContext';
import {
	User,
	Mail,
	Calendar,
	Shield,
	Edit3,
	Camera,
	Settings,
	Star,
	MessageSquare,
	Heart,
	FileText,
	Award,
} from 'lucide-react';
import Placeholder from '../../Media/Team/placeholder.png';

const Profile = () => {
	const { user } = useUser();
	const navigate = useNavigate();
	const [isEditing, setIsEditing] = useState(false);
	const [editForm, setEditForm] = useState({
		name: '',
		email: '',
		phone: '',
		bio: '',
	});
	const [activeTab, setActiveTab] = useState('overview');
	const [userStats] = useState({
		totalPosts: 12,
		totalLikes: 145,
		totalComments: 67,
		reportsSubmitted: 8,
	});

	useEffect(() => {
		if (!user) {
			navigate('/login');
			return;
		}

		setEditForm({
			name: user.name || '',
			email: user.email || '',
			phone: '',
			bio: 'Passionate about authentic reporting and community safety.',
		});
	}, [user, navigate]);

	if (!user) {
		return (
			<div className='min-h-screen bg-gray-100 flex items-center justify-center'>
				<div className='text-center'>
					<div className='animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4'></div>
					<p className='text-gray-600'>Loading profile...</p>
				</div>
			</div>
		);
	}

	return (
		<div className='min-h-screen bg-gray-100'>
			{/* Header */}
			{/* <header className='fixed top-0 left-0 right-0 z-50 bg-white shadow-lg border-b border-gray-200'> */}
			{/* <div className='flex items-center justify-between px-6 py-3'> */}
			{/* Logo */}
			{/* <button
            className='flex items-center gap-4 hover:scale-105 transition-transform duration-200'
            onClick={() => navigate('/')}
          >
            <img src={BReporter} className='w-10 h-10' alt="B-Reporter" />
            <div className='text-[#022c56]'>
              <h3 className='text-xl font-bold leading-tight'>B-Reporter</h3>
              <p className='text-xs text-gray-600'>Authentic Reporting</p>
            </div>
          </button> */}

			{/* Navigation Links */}
			{/* <nav className='flex items-center gap-6'>
            <button
              className='px-4 py-2 text-[#022c56] hover:bg-blue-50 rounded-lg transition-colors font-medium'
              onClick={() => navigate('/')}
            >
              Home
            </button>

            <button
              className='px-4 py-2 text-[#022c56] hover:bg-blue-50 rounded-lg transition-colors font-medium'
              onClick={() => navigate('/news')}
            >
              My News
            </button>

            {user?.is_authority &&
              <button
                className='px-4 py-2 text-[#022c56] hover:bg-blue-50 rounded-lg transition-colors font-medium'
                onClick={() => navigate('/reports')}
              >
                My Reports
              </button>
            }

            <button
              className='px-4 py-2 text-[#022c56] hover:bg-blue-50 rounded-lg transition-colors font-medium'
              onClick={() => navigate('/contact')}
            >
              Contact
            </button>

            {isAdmin && isLoggedIn && (
              <button
                className='px-4 py-2 text-[#022c56] hover:bg-blue-50 rounded-lg transition-colors font-medium'
                onClick={() => navigate('/admin')}
              >
                Admin Panel
              </button>
            )}
          </nav> */}

			{/* Auth Button */}
			{/* <button
            className='px-4 py-2 text-[#022c56] hover:bg-gray-100 rounded-lg transition-colors font-medium border border-[#022c56]'
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </header> */}

			{/* Main Content */}
			<div className='pt-20 pb-8'>
				<div className='max-w-4xl mx-auto px-6'>
					{/* Profile Header */}
					<div className='bg-white rounded-2xl shadow-sm border border-gray-200 mb-8 overflow-hidden'>
						{/* Cover Image */}
						<div className='h-48 bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 relative'>
							<div className='absolute inset-0 bg-black/20'></div>
							<div className='absolute bottom-6 left-6 right-6'>
								<div className='flex items-end justify-between'>
									{/* Profile Picture */}
									<div className='relative'>
										<div className='w-32 h-32 rounded-full border-4 border-white shadow-lg overflow-hidden bg-white'>
											<img
												src={user.profilepicURL || Placeholder}
												alt={user.name}
												className='w-full h-full object-cover'
											/>
										</div>
										<button className='absolute bottom-2 right-2 w-10 h-10 bg-blue-600 hover:bg-blue-700 rounded-full flex items-center justify-center text-white shadow-lg transition-colors'>
											<Camera className='w-5 h-5' />
										</button>
									</div>

									{/* Action Buttons */}
									<div className='flex gap-3 mb-4'>
										<button
											onClick={() => setIsEditing(!isEditing)}
											className='px-6 py-2 bg-white text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors shadow-md border border-gray-200'
										>
											<Edit3 className='w-4 h-4 inline mr-2' />
											{isEditing ? 'Cancel' : 'Edit Profile'}
										</button>
										<button className='px-6 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors shadow-md'>
											<Settings className='w-4 h-4 inline mr-2' />
											Settings
										</button>
									</div>
								</div>
							</div>
						</div>

						{/* Profile Info */}
						<div className='p-6 pt-8'>
							<div>
								<h1 className='text-3xl font-bold text-gray-900 mb-2'>{user.name}</h1>
								<div className='flex items-center gap-6 text-gray-600 mb-4'>
									<div className='flex items-center gap-2'>
										<Mail className='w-4 h-4' />
										<span>{user.email}</span>
									</div>

									<div className='flex items-center gap-2'>
										<Calendar className='w-4 h-4' />
										<span>Joined {new Date().toLocaleDateString()}</span>
									</div>
								</div>

								{user.is_authority && (
									<div className='flex items-center gap-2 mb-4'>
										<Shield className='w-5 h-5 text-blue-600' />
										<span className='text-blue-600 font-medium'>Verified Authority</span>
									</div>
								)}

								<p className='text-gray-700 leading-relaxed mb-6'>{editForm.bio}</p>

								{/* Stats Cards */}
								<div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
									<div className='bg-blue-50 rounded-lg p-4 text-center'>
										<FileText className='w-6 h-6 text-blue-600 mx-auto mb-2' />
										<div className='text-2xl font-bold text-blue-600'>{userStats.totalPosts}</div>
										<div className='text-sm text-gray-600'>Posts</div>
									</div>
									<div className='bg-red-50 rounded-lg p-4 text-center'>
										<Heart className='w-6 h-6 text-red-600 mx-auto mb-2' />
										<div className='text-2xl font-bold text-red-600'>{userStats.totalLikes}</div>
										<div className='text-sm text-gray-600'>Likes</div>
									</div>
									<div className='bg-green-50 rounded-lg p-4 text-center'>
										<MessageSquare className='w-6 h-6 text-green-600 mx-auto mb-2' />
										<div className='text-2xl font-bold text-green-600'>{userStats.totalComments}</div>
										<div className='text-sm text-gray-600'>Comments</div>
									</div>
									<div className='bg-purple-50 rounded-lg p-4 text-center'>
										<Award className='w-6 h-6 text-purple-600 mx-auto mb-2' />
										<div className='text-2xl font-bold text-purple-600'>{userStats.reportsSubmitted}</div>
										<div className='text-sm text-gray-600'>Reports</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* Content Tabs */}
					<div className='bg-white rounded-2xl shadow-sm border border-gray-200'>
						{/* Tab Navigation */}
						<div className='border-b border-gray-200'>
							<nav className='flex space-x-8 px-6'>
								{[
									{ id: 'overview', label: 'Overview', icon: User },
									{ id: 'posts', label: 'My Posts', icon: FileText },
									{ id: 'activity', label: 'Activity', icon: Star },
								].map((tab) => {
									const Icon = tab.icon;
									return (
										<button
											key={tab.id}
											onClick={() => setActiveTab(tab.id)}
											className={`py-4 px-2 border-b-2 font-medium text-sm flex items-center gap-2 transition-colors ${
												activeTab === tab.id
													? 'border-blue-500 text-blue-600'
													: 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
											}`}
										>
											<Icon className='w-4 h-4' />
											{tab.label}
										</button>
									);
								})}
							</nav>
						</div>

						{/* Tab Content */}
						<div className='p-6'>
							{activeTab === 'overview' && (
								<div className='space-y-6'>
									<div>
										<h3 className='text-lg font-semibold text-gray-900 mb-4'>Account Information</h3>
										<div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
											<div className='space-y-4'>
												<div>
													<label className='block text-sm font-medium text-gray-700'>User ID</label>
													<p className='mt-1 text-sm text-gray-900'>#{user.id}</p>
												</div>
												<div>
													<label className='block text-sm font-medium text-gray-700'>Account Type</label>
													<p className='mt-1 text-sm text-gray-900'>
														{user.is_authority ? 'Authority Account' : 'Regular User'}
													</p>
												</div>
											</div>
											<div className='space-y-4'>
												<div>
													<label className='block text-sm font-medium text-gray-700'>Member Since</label>
													<p className='mt-1 text-sm text-gray-900'>
														{new Date().toLocaleDateString('en-US', {
															year: 'numeric',
															month: 'long',
															day: 'numeric',
														})}
													</p>
												</div>
												<div>
													<label className='block text-sm font-medium text-gray-700'>Status</label>
													<span className='inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800'>
														Active
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							)}

							{activeTab === 'posts' && (
								<div className='text-center py-12'>
									<FileText className='w-12 h-12 text-gray-400 mx-auto mb-4' />
									<h3 className='text-lg font-medium text-gray-900 mb-2'>Your Posts</h3>
									<p className='text-gray-500 mb-6'>Your posts and contributions will appear here</p>
									<button
										onClick={() => navigate('/news')}
										className='px-6 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors'
									>
										View All Posts
									</button>
								</div>
							)}

							{activeTab === 'activity' && (
								<div className='text-center py-12'>
									<Star className='w-12 h-12 text-gray-400 mx-auto mb-4' />
									<h3 className='text-lg font-medium text-gray-900 mb-2'>Recent Activity</h3>
									<p className='text-gray-500'>Your recent activity and interactions will appear here</p>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Profile;
